/**
 *
 * @module entry
 * @desc {SDK.CustomerService} entry point.
 *
 */

import CustomerServiceManager from './customerServiceManager';

/**
 *
 * @typedef SDK.CustomerService
 * @type {Object}
 *
 * @property {CustomerServiceManager} CustomerServiceManager
 *
 */

/**
 *
 * @type {SDK.CustomerService}
 *
 */
export default {

    CustomerServiceManager

};



// WEBPACK FOOTER //
// ./src/customerService/entry.js